var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 16.772696,11.08016 c 0.6636,0.38904 0.6636,1.36164 0,1.750695 L 8.263706,17.81855 C 7.6000156,18.20765 6.7703956,17.72135 6.7703956,16.9433 V 6.9677749 c 0,-0.778095 0.82962,-1.264395 1.4933104,-0.875355 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaPlay);
export default __webpack_public_path__ + "static/media/MediaPlay.0f58113888b927572d22d41b66321100.svg";
export { ForwardRef as ReactComponent };